import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M3.805 11.906a.75.75 0 0 1-.65.838c-.47.06-.967.278-1.242.528-.135.121-.16.2-.164.213a.2.2 0 0 0 .03.055.8.8 0 0 0 .26.052c.264.022.633-.005 1.103-.078.693-.108 1.486-.298 2.316-.496.303-.073.61-.146.92-.217 1.099-.253 2.276-.49 3.14-.418.429.037.956.162 1.313.578.323.376.384.838.318 1.284.152.01.372.005.666-.03.9-.111 2.076-.452 2.914-.776a.75.75 0 1 1 .54 1.4c-.91.35-2.211.734-3.272.864-.507.062-1.075.083-1.526-.068a1.287 1.287 0 0 1-.71-.536c-.193-.318-.196-.665-.12-.96a.814.814 0 0 0 .033-.205.964.964 0 0 0-.282-.056c-.589-.05-1.53.12-2.677.385-.277.063-.563.132-.853.2-.85.204-1.732.415-2.488.533-.51.08-1.018.127-1.46.09-.415-.034-.95-.157-1.296-.595-.307-.388-.434-.845-.337-1.31.089-.432.35-.773.624-1.02.542-.492 1.343-.814 2.062-.905a.75.75 0 0 1 .838.65Zm5.864 1.989.002.01a.033.033 0 0 1-.002-.01Z",
  "clip-rule": "evenodd"
}, null, -1), a = /* @__PURE__ */ e("path", { d: "m9.913 2.964 2.122 2.122-4.95 4.95-2.121-2.122 4.95-4.95Zm1.061-1.06a1.5 1.5 0 0 1 2.121 0m-9.192 9.192 2.475-.354-2.122-2.12-.353 2.474Z" }, null, -1), l = [
  n,
  a
];
function d(r, s) {
  return t(), o("svg", c, [...l]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
